export default __webpack_public_path__ + "static/media/Group 3188@2x.e9cc5324.png";